import { render, staticRenderFns } from "./wireless.vue?vue&type=template&id=45e9f025&scoped=true&"
import script from "./wireless.vue?vue&type=script&lang=js&"
export * from "./wireless.vue?vue&type=script&lang=js&"
import style0 from "./wireless.vue?vue&type=style&index=0&id=45e9f025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e9f025",
  null
  
)

export default component.exports